<template>
    <header>
        <h1>Lights Out!</h1>
    </header>
    <div>
        <p>
            Click on the squares to turn change the lights. Try to get all the lights out.
        </p>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
header {
    width: 100%;
    background-color: aqua;
    text-align: center;
    font-family: sans-serif;
    margin: 0;
    font-size: 1.6em;
}
div {
    text-align: center;
}
h1 {
    color: #333;
}
</style>